import request from "../utils/request";

/// addObjectCompany

export function getComponentsByPollutionSource(data) {
  //получаю все компоненты по источнику   source_id=1
  return request({
    url: "/api/company-objects/component-normatives-by-polution-soource/",
    method: "get",
    params: data
  });
}

export function getAllObjectCompany(params) {
  return request({
    url: "/api/company-objects/objects/",
    method: "get",
    params
  });
}

export function getMonitoringObject(params) {
  return request({
    url: "/api/company-objects/graph_actual_concentration/",
    method: "get",
    params
  });
}
export function getAllObjectCompanyMap(params) {
  // Приходят все компании для карты
  return request({
    url: "/api/company-objects/company-objects-map/",
    method: "get",
    params
  });
}

export function getObjectCompanyWithFilters(params) {
  // Запрос объектов с помощью фильтра
  /*  {
        ministry_id: id,
        region_id: id,
        status: int( 0 =  false, 1 =  true) ,
        secret: int( 0 =  false, 1 =  true) ,
        activity_field: id,
        ecology_type: id,
        danger_category: id
      }*/
  return request({
    url: "/api/company-objects/objects/",
    method: "get",
    params
  });
}

export function getObjectByInn(params) {
  //  получение объекта по инн
  return request({
    url: `/api/company-objects/company_objects_inn/`,
    method: "get",
    params
  });
}

export function getExpertiseList(data) {
  return request({
    url: `/api/company-objects/epigu_card/binding_epigu_to_company_objects_get/?epigu_card_id=${data.id}`,
    method: "get",
    params: data
  });
}

export function getExpertiseListMain(data) {
  return request({
    url: `/api/company-objects/epigu_card/binding_epigu_to_company_objects_detail/${data.id}/`,
    method: "get",
    params: data
  });
}

export function getObjectCompany(data) {
  return request({
    url: `/api/company-objects/objects/${data}`,
    method: "get"
  });
}

export function addObjectCompany(data) {
  return request({
    url: "/api/company-objects/objects/",
    method: "post",
    data
  });
}

export function editExpertiseSave(data) {
  return request({
    url: `/api/company-objects/epigu_card/binding_epigu_to_company_objects_patch/${data.id}/`,
    method: "patch",
    data: data.data
  });
}

export function editObjectCompany(data) {
  return request({
    url: "/api/company-objects/objects/",
    method: "put",
    data
  });
}

export function deleteObjectCompany(data) {
  return request({
    url: "/api/company-objects/objects/",
    method: "delete",
    data
  });
}

// Polution Source Источники для объектов

export function getObjectPollutionSourceDiagrams(id) {
  return request({
    url: `/api/company-objects/get_polustion_source_by_object_detail/${id}`,
    method: "get"
  });
}

export function getObjectPollutionSource(data) {
  return request({
    url: `/api/company-objects/polution-sources-of-object/${data}`,
    method: "get"
  });
}

export function getObjectPollutionSourceForMap(data) {
  return request({
    url: `/api/company-objects/polution-source/${data}`,
    method: "get"
  });
}

export function getObjectPollutionSourceForMapMonitoring(data) {
  return request({
    url: `/api/knowledge-base/get_mchs_maps_list/${data}/`,
    method: "get"
  });
}

export function getObjectPollutionSourceForMapWater(id) {
  return request({
    url: `/api/knowledge-base/get_reservoir_detail/${id}/`,
    method: "get"
  });
}

export function getAllObjectPollutionSource() {
  return request({
    url: "/api/company-objects/polution-source/",
    method: "get"
  });
}

export function addObjectPollutionSource(data) {
  return request({
    url: "/api/company-objects/polution-source/",
    method: "post",
    data
  });
}

export function editObjectPollutionSource(data) {
  return request({
    url: "/api/company-objects/polution-source/",
    method: "put",
    data
  });
}

export function deleteObjectPollutionSource(data) {
  return request({
    url: "/api/company-objects/polution-source/",
    method: "delete",
    data
  });
}

export function getAllObjectPollutionSourcesForMap(params) {
  return request({
    url: "/api/company-objects/polution-sources-map/",
    method: "get",
    params,
  });
}

export function getAllMapMonitoring(params) {
  return request({
    url: "/api/knowledge-base/get_mchs_table_list/",
    method: "get",
    params,
  });
}
export function getAllMapMonitoringDetail(params) {
  return request({
    url: "/api/knowledge-base/get_mchs_table_detail/",
    method: "get",
    params,
  });
}
export function getAllMapMonitoringMap(params) {
  return request({
    url: "/api/knowledge-base/get_mchs_maps_list/",
    method: "get",
    params,
  });
}

export function getAllMapMonitoringMapConfirmation(id) {
  return request({
    url: `/api/knowledge-base/get_mchs_maps_read/${id}/`,
    method: "get",

  });
}

export function getAllObjectPollutionSourcesForMapId(id) {
  return request({
    url: `/api/company-objects/polution-sources-map/${id}/`,
    method: "get"
  });
}

// Polution Source Normative Нормативы для компонентов источников  (объектов)
//Получение всех загрязнителей определенного источника
export function getObjectPollutionSourceNormative(params) {
  return request({
    url: "/api/company-objects/get-normative-by-source/",
    method: "get",
    params
  });
}

export function getAllObjectPollutionSourceNormative() {
  return request({
    url: "/api/company-objects/polution-source-normative/",
    method: "get"
  });
}

export function addObjectPollutionSourceNormative(data) {
  return request({
    url: "/api/company-objects/components-normatives-v2/",
    method: "post",
    data
  });
  // return request({
  //   url: '/api/company-objects/polution-source-normative/',
  //   method: 'post',
  //   data,
  // })
}

export function editObjectPollutionSourceNormative(data) {
  return request({
    url: `/api/company-objects/components-normatives-v2/${data.id}/`,
    method: "put",
    data
  });
}

export function deleteObjectPollutionSourceNormative({data}) {
  return request({
    url: `/api/company-objects/components-normatives-v2/${data.id}/`,
    method: "delete"
  });
}

export function getSelectObjectSourcesList(id) {
  return request({
    url: `/api/company-objects/polution-sources-of-object/${id}?partial=true`,
    method: "get"
  });
}

export function getObjectPollutionSourceNormativeCharts(params) {
  return request({
    url: `/api/company-objects/polution-sources-of-object-statistics/`,
    method: "get",
    params
  });
}


//
export function getObjectCountCompanyRegion(params) {
  return request({
    url: "/api/company-objects/count-companies-region/",
    method: "get",
    params
  });
}
